import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, unref as _unref, isRef as _isRef, withKeys as _withKeys, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "flex flex-col gap-4" }
const _hoisted_2 = { class: "flex items-center gap-3" }
const _hoisted_3 = { class: "text-sm text-gray-500 dark:text-gray-400" }
const _hoisted_4 = { class: "flex gap-10" }
const _hoisted_5 = { class: "flex flex-col gap-3 max-w-sm" }
const _hoisted_6 = { class: "flex items-center gap-2" }
const _hoisted_7 = {
  key: 0,
  class: "w-full"
}
const _hoisted_8 = {
  key: 0,
  class: "text-sm text-red-600 mt-1"
}
const _hoisted_9 = {
  key: 1,
  class: "text-sm text-green-600"
}

import type { FooterColumn } from "@nuxt/ui";


export default /*@__PURE__*/_defineComponent({
  __name: 'MainFooter',
  setup(__props) {

const auth = useAuthStore();

const newsletterEmail = ref<string>("");
const newsletterSubmitted = ref(false);
const newsletterError = ref<string>("");

const isValidEmail = (email: string): boolean => {
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return emailRegex.test(email);
};

async function submitNewsletter() {
  if (!newsletterEmail.value || !isValidEmail(newsletterEmail.value)) {
    newsletterError.value = "Please enter a valid email address";
    setTimeout(() => (newsletterError.value = ""), 5000);
    return;
  }

  try {
    await auth.addContact(newsletterEmail.value);
    newsletterSubmitted.value = true;
    newsletterEmail.value = "";
  } catch (error) {
    newsletterError.value = error instanceof Error ? error.message : String(error);
    setTimeout(() => (newsletterError.value = ""), 5000);
  }
}

const discoverColumns: FooterColumn[] = [
  {
    label: "Features",
    children: [
      {
        label: "Family Engagement",
        to: "/more/family-engagement",
      },
      {
        label: "Resident Profiles",
        to: "/more/resident-profiles",
      },
      {
        label: "Direct Work",
        to: "/more/direct-work",
      },
      {
        label: "Progress & Observations",
        to: "/more/progress-observations",
      },
      {
        label: "Tasks & Collaboration",
        to: "/more/team-collaboration",
      },
      {
        label: "Centralised Dashboard",
        to: "/more/centralised-dashboard",
      },
    ],
  },
];

const generalColumns: FooterColumn[] = [
  {
    label: "Company",
    children: [
      {
        label: "About",
        to: "/about",
      },
      {
        label: "Contact us",
        to: "/contact-sale",
      },
      {
        label: "Terms of Service",
        to: "/terms",
      },
      {
        label: "Privacy Policy",
        to: "/privacy-policy",
      },
      {
        label: "Refund Policy",
        to: "/refund-policy",
      },
      {
        label: "Data Protection Addendum",
        to: "/dpa",
      },
    ],
  },
];

return (_ctx: any,_cache: any) => {
  const _component_UColorModeImage = _resolveComponent("UColorModeImage")!
  const _component_UFooterColumns = _resolveComponent("UFooterColumns")!
  const _component_UIcon = _resolveComponent("UIcon")!
  const _component_UButton = _resolveComponent("UButton")!
  const _component_UInput = _resolveComponent("UInput")!
  const _component_UFooter = _resolveComponent("UFooter")!

  return (_openBlock(), _createBlock(_component_UFooter, { class: "pt-24 pb-10" }, {
    left: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_UColorModeImage, {
            light: "/images/logo_light.svg",
            dark: "/images/logo_dark.svg",
            alt: "FamilyAxis logo",
            class: "h-8"
          }),
          _createVNode(_component_UColorModeImage, {
            light: "./images/familyaxis.svg",
            dark: "./images/familyaxis_dark.svg",
            alt: "FamilyAxis",
            class: "h-5"
          })
        ]),
        _cache[1] || (_cache[1] = _createElementVNode("p", { class: "text-sm text-gray-600 dark:text-gray-400 max-w-xs" }, " Your all-in-one software for residential family centres and parenting assessments. ", -1)),
        _createElementVNode("p", _hoisted_3, " Copyright FamilyAxis Software Ltd © " + _toDisplayString(new Date().getFullYear()), 1)
      ])
    ]),
    right: _withCtx(() => [
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _createVNode(_component_UIcon, {
            name: "i-heroicons-envelope",
            class: "h-5 w-5 text-gray-600 dark:text-gray-400"
          }),
          _cache[2] || (_cache[2] = _createElementVNode("h2", { class: "font-semibold text-gray-900 dark:text-white" }, "Newsletter", -1))
        ]),
        _cache[3] || (_cache[3] = _createElementVNode("p", { class: "text-sm text-gray-600 dark:text-gray-400" }, "Stay updated with FamilyAxis", -1)),
        (!_unref(newsletterSubmitted))
          ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
              _createVNode(_component_UInput, {
                modelValue: _unref(newsletterEmail),
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(newsletterEmail) ? (newsletterEmail).value = $event : null)),
                type: "email",
                placeholder: "Enter your email",
                size: "sm",
                class: "w-full",
                onKeyup: _withKeys(submitNewsletter, ["enter"])
              }, {
                trailing: _withCtx(() => [
                  _createVNode(_component_UButton, {
                    size: "sm",
                    color: "primary",
                    icon: "i-heroicons-arrow-right",
                    "aria-label": "Subscribe to newsletter",
                    onClick: submitNewsletter
                  })
                ]),
                _: 1
              }, 8, ["modelValue"]),
              (_unref(newsletterError))
                ? (_openBlock(), _createElementBlock("p", _hoisted_8, _toDisplayString(_unref(newsletterError)), 1))
                : _createCommentVNode("", true)
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_9, "Thanks! You're on the list."))
      ])
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_UFooterColumns, { columns: discoverColumns }),
        _createVNode(_component_UFooterColumns, { columns: generalColumns })
      ])
    ]),
    _: 1
  }))
}
}

})